export var NewDeviceType;
(function (NewDeviceType) {
    NewDeviceType["Controller"] = "Controller";
    NewDeviceType["Screen"] = "Screen";
    NewDeviceType["Projection"] = "Projection";
})(NewDeviceType || (NewDeviceType = {}));
